export const FREE_TEXT_RESPONSE_ID = 4;
export const DATE_TYPE_RESPONSE_ID = 3;
export const SINGLE_SELECT_RESPONSE_ID = 1;
export const MULTI_SELECT_RESPONSE_ID = 2;
export const FILE_UPLOAD_RESPONSE_ID = 5;
